import { api } from '../api';
import { MultiFactorAuthenticationType } from './list';

const AUTHORIZATION_VALUE_PREFIX = 'mfasession';

interface MultiFactorAuthenticationActivateRequest {
  token?: string;
  type: MultiFactorAuthenticationType;
}

const activate = async ({ token, type }: MultiFactorAuthenticationActivateRequest, { authToken }: { authToken: string }) =>
  api.post<void>(
    '/multiFactorAuthentication.activate',
    { token, type },
    {
      Authorization: `${AUTHORIZATION_VALUE_PREFIX} ${authToken}`,
    },
  );

export default activate;
